<template>
  <div>
    <jd-form
      class="mb16"
      :formData="searchInfo"
      :form-info="getClockInDetailsFormInfo"
      @search="getClockInDetails"
      ref="funGameRecordRef"
    ></jd-form>
    <div style="margin-bottom: 16px" class="flex-between">
      <div>
        <jd-button
          type="blueLine"
          :disabled="!dataSource.length"
          @click="addCrowd"
          >按查询结果生成人群</jd-button
        >
        <jd-button :disabled="!selectedRows.length" @click="batchAudit"
          >批量审核</jd-button
        >
      </div>
      <jd-button type="text" :disabled="!dataSource.length" @click="exportAll"
        >导出</jd-button
      >
    </div>
    <div class="new-table-box">
      <jd-table
        v-loading="loading"
        :tableData="dataSource"
        :tableInfo="tableInfo"
        :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
        :cell-style="{ 'text-align': 'left' }"
        style="width: 100%"
        row-key="id"
        :pageInfo="{
          pageNum: formList.current,
          pageSize: formList.size,
          total: total,
        }"
        :selection="selection"
        :selectable="selectable"
        @handleSelectionChange="handleSelectionChange"
        @handlePage="handleCurrentChangeAll"
      >
        <template #signPatternSlot="{ row }">
          <div>{{ row.signPattern == 0 ? "图文打卡" : "签到打卡" }}</div>
        </template>
        <template #fileUrlSlot="{ row }">
          <el-popover placement="top-start" trigger="hover" offset="100">
            <div style="text-align: center">
              <!-- 根据后缀区分图片和视频 -->
              <div v-for="item in getUrlList(row.fileUrl)" :key="item">
                <el-image
                  v-if="isImage(item)"
                  :key="item"
                  style="width: 90px; height: 90px; cursor: pointer"
                  :src="item"
                  :preview-src-list="[item]"
                />
                <video
                  v-else
                  style="width: 90px; height: 90px; cursor: pointer"
                  :src="item"
                  @click="openVideo(item)"
                ></video>
              </div>
            </div>
            <div slot="reference" class="overEllipsis" style="width: 200px">
              <div v-for="item in getUrlList(row.fileUrl)" :key="itm">
                <el-image
                  v-if="isImage(item)"
                  :key="item"
                  style="
                    width: 50px;
                    height: 50px;
                    margin-right: 10px;
                    cursor: pointer;
                  "
                  :src="item"
                />
                <video
                  v-else
                  style="
                    width: 50px;
                    height: 50px;
                    margin-right: 10px;
                    cursor: pointer;
                  "
                  :src="item"
                ></video>
              </div>
            </div>
          </el-popover>
        </template>
        <template #relatedProductsSlot="{ row }">
          <div>
            <!-- <div v-if="row.wareId"> -->
              <a
                :href="`http://item.jd.com/${row.wareId}.html`"
                target="_blank"
                v-if="row.wareId"
              >
                <span
                  class="themeColor"
                  style="
                    display: inline-block;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  "
                  v-if="row.title"
                  >{{ row.title }}<br /></span
                >
                <span style="color: #666666">商品id：{{ row.wareId }}</span>
              </a>
            <!-- </div> -->
            <div v-else>-</div>
          </div>
        </template>
        <template #relatedOrdersSlot="{ row }">
          <div v-if="row.orderIds">{{ row.orderIds }}</div>
          <div v-else>-</div>
        </template>
        <template #signTypeSlot="{ row }">
          <span>{{ row.signType ? "是" : "否" }}</span>
        </template>
        <template #statusSlot="{ row }">
          <jd-status v-if="row.status == 0" :status="2">待审核</jd-status>
          <jd-status v-else-if="row.status == 1" :status="0">审核通过</jd-status>
          <jd-status v-else-if="row.status == 2" :status="3">审核拒绝</jd-status>
          <span v-else>审核通过</span>
          <el-tooltip
            v-if="row.status == 2"
            effect="dark"
            :content="row.rejectReason || ''"
            placement="top-start"
          >
            <span class="new-icon-box"></span>
          </el-tooltip>
        </template>
        <template #operationSlot="{ row }">
          <jd-button
            type="blueText"
            @click="audit(row)"
            :disabled="row.status != 0"
            >审核</jd-button
          >
        </template>
      </jd-table>
    </div>
    <!-- 生成人群 -->
    <crowdDialog
      v-if="isShowCrowdDialog"
      :isShowCrowdDialog.sync="isShowCrowdDialog"
      :activityType="rowData.activityType"
      :source="54"
      :defaultValue="hasDefaultValue"
      :defaultValueText="defaultValueText"
      :searchForm="crowCondition"
      @close="crowdClose"
    />

    <!-- 导出 -->
    <generate
      :control="openRemarkDialog"
      v-if="openRemarkDialog"
      @transData="(val) => (openRemarkDialog = val)"
      @transData1="confirmExport"
    ></generate>
    <!-- 审核弹窗 -->
    <auditInfo
      v-model="isShowDialog"
      :isBatch="isBatch"
      :rowData="auditRowData"
      :activityId="rowData.id"
      :proccessSelection="selectedRows"
      :actType="84"
      @update="getList()"
    />
    <jd-dialog
      :visible.sync="isOpenVideo"
      @closed="closeVideo"
      width="750px"
      :isShowCancel="false"
      :isShowSure="false"
    >
      <div style="text-align: center; min-width: 400px">
        <video
          v-if="isOpenVideo"
          ref="videoPlayer"
          :src="videoUrl"
          controls="controls"
          style="height: 700px; width: 700px"
        ></video>
      </div>
    </jd-dialog>
  </div>
</template>

<script>
import crowdDialog from "@/views/interactiveMarketing/activity/crowd-Dialog.vue";
import auditInfo from "../xhsRecord/auditInfo.vue";
import {
  getCalendarCheckInDetail,
  getCalendarCheckInDetailExport,
} from "@/api/jhk/paradiseAndTaskCommonController.js";
import { useTablePinText } from "@/common/hook";
export default {
  components: {
    crowdDialog,
    auditInfo,
  },
  props: {
    inputInfo: {
      type: Array,
      default: () => [],
    },
    rowData: {
      type: Object,
      default: () => {},
    },
    levelMap: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      isShowDialog: false,
      auditRowData: {},
      isBatch: false,
      selectedRows: {},
      selection: true,
      total: 0,
      formList: {
        size: 10,
        current: 1,
      },
      dataSource: [],
      loading: false,
      searchInfo: {
        nickName: "",
        pin: "",
        sellerLinkId: "",
        firstCheckInStartTime: "",
        firstCheckInEndTime: "",
        latestCheckInStartTime: "",
        latestCheckInEndTime: "",
      }, // 搜索参数
      isShowCrowdDialog: false, // 生成人群
      hasDefaultValue: true, // 是否有默认值
      defaultValueText: "参与记录", // 默认值文本
      openRemarkDialog: false, // 导出备注弹窗
      crowCondition: {},
      tableInfo: [
        {
          prop: "sellerLinkName",
          label: "投放渠道",
          width: 140,
        },
        {
          prop: "memberNick",
          label: "用户昵称",
          width: 140,
        },
        {
          prop: "chaosPin",
          label: "用户pin（加密）",
          width: "minText",
        },
        {
          prop: "signPattern",
          slot: "signPatternSlot",
          label: "打卡模式",
          width: 140,
        },
        {
          prop: "fileUrl",
          slot: "fileUrlSlot",
          label: "图片/视频",
          width: 200,
        },
        {
          prop: "signInfo",
          label: "文案",
          type: "scalable",
          width: 200,
        },
        {
          prop: "relatedProducts",
          label: "关联商品",
          slot: "relatedProductsSlot",
          width: 200,
        },
        {
          prop: "orderIds",
          label: "关联订单",
          slot: "relatedOrdersSlot",
          width: 200,
        },
        {
          prop: "signTime",
          label: "打卡时间",
          width: "minTime",
        },
        {
          prop: "signType",
          label: "是否补卡",
          slot: "signTypeSlot",
          width: 140,
        },
        {
          prop: "status",
          label: "审核状态",
          slot: "statusSlot",
          width: 140,
        },
        {
          prop: "auditTime",
          label: "审核时间",
          width: "minTime",
        },
        {
          prop: "operation",
          label: "操作",
          slot: "operationSlot",
          fixed: "right",
          width: "minText",
        },
      ],
      videoUrl: "",
      isOpenVideo: false,
    };
  },
  computed: {
    getClockInDetailsFormInfo: {
      get() {
        return this.inputInfo;
      },
      set(val) {
        this.$emit("update:inputInfo", val);
      },
    },
    searchGrayId() {
      return this.$store.getters.loginUserInfo.isGray ? 'xid' : 'pin'
    },
    grayText() {
      return this.$store.getters.loginUserInfo.isGray ? 'xid' : 'pin（加密）'
    },
  },
  watch: {
    grayText: {
      handler(newVal, oldVal) {
        useTablePinText(newVal,[this.tableInfo])
      },
      immediate: true,
    }
  },
  mounted() {
    this.getList();
  },
  methods: {
    selectable(row, index) {
      if (row.status == 0) {
        return true;
      } else {
        return false;
      }
    },
    isImage(url) {
      return (
        url.endsWith(".jpg") || url.endsWith(".jpeg") || url.endsWith(".png")
      );
    },
    getUrlList(url) {
      if (url) {
        return url.split(",");
      } else {
        return [];
      }
    },
    handleSelectionChange(val) {
      this.selectedRows = val;
    },
    openVideo(url) {
      this.videoUrl = url;
      this.isOpenVideo = true;
    },
    audit(row) {
      this.auditRowData = row;
      this.isBatch = false;
      this.isShowDialog = true;
    },
    batchAudit() {
      if (this.selectedRows.length > 0) {
        this.isBatch = true;
        this.isShowDialog = true;
      } else {
        this.$message({
          message: "请选择要审核的打卡明细",
          type: "warning",
        });
      }
    },
    handleToTab(val) {
      this.$emit("handleToTabCb", val);
    },
    handleCurrentChangeAll(val) {
      this.formList.size = val.pageSize;
      this.formList.current = val.pageNum;
      this.getList();
    },
    /**
     * 搜索
     * @param params 查询参数
     * @param type 类型 reset 重置  search 搜索
     */
    getClockInDetails(params) {
      this.formList.current = 1;
      this.formList.size = 10;
      this.searchInfo.memberNick = params.memberNick ? params.memberNick : "";
      // this.searchInfo.pin = params.pin ? params.pin : "";
      this.searchInfo[this.searchGrayId] = params[this.searchGrayId] ? params[this.searchGrayId] : "";
      this.searchInfo.sellerLinkId = params.sellerLinkId
        ? params.sellerLinkId
        : "";
      this.searchInfo.signTimeStart = params.signTimeStart
        ? params.signTimeStart
        : "";
      this.searchInfo.signTimeEnd = params.signTimeEnd
        ? params.signTimeEnd
        : "";
      this.searchInfo.auditTimeStart = params.auditTimeStart
        ? params.auditTimeStart
        : "";
      this.searchInfo.auditTimeEnd = params.auditTimeEnd
        ? params.auditTimeEnd
        : "";
      this.searchInfo.status = params.status >= 0 ? params.status : "";
      this.getList();
    },
    async getList() {
      try {
        this.loading = true;
        const params = {
          ...this.searchInfo,
          ...this.formList,
          activityId: this.rowData.id,
        };
        this.crowCondition = {
          ...params,
          activityType: this.rowData.activityType,
        };
        const res = await getCalendarCheckInDetail(params);
        let { records = [], total = 0 } = res.data;
        this.dataSource = records;
        this.total = Number(total);
      } catch (error) {
      } finally {
        this.loading = false;
      }
    },
    /**
     * 生成人群
     */
    addCrowd() {
      this.hasDefaultValue = true;
      this.defaultValueText = "参与记录-";
      this.isShowCrowdDialog = true;
    },
    crowdClose() {
      this.isShowCrowdDialog = false;
      // 关闭时重置
      if (this.hasDefaultValue) {
        this.hasDefaultValue = false;
        this.defaultValueText = "";
      }
    },
    /**
     * 导出
     */
    exportAll() {
      this.openRemarkDialog = true;
    },
    /**
     * 确认导出
     * @param exportRemark 备注内容
     */
    confirmExport(remark = "") {
      let params = {
        ...this.formList,
        ...this.searchInfo,
        activityId: this.rowData.id,
        remark,
      };
      this.formLoading = true;
      getCalendarCheckInDetailExport(params).then((res) => {
        this.formLoading = false;
        if (res.code == 1) {
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.flex-between {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
.themeColor {
  color: #3159ff;
}
</style>
